<template>
  <div class="modal" :class="{ 'is-active': is_open }">
    <div class="modal-background" @click="close"></div>
    <div class="modal-card is-fullscreen">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ $t("evaluation comment") }}
        </p>
        <button class="delete" @click="close"></button>
      </header>
      <section class="modal-card-body">
        <form @submit.prevent="save">
          <!-- Basic fields -->
          <div class="field">
            <label class="label">{{ $t("comment") }}</label>
            <div class="control">
              <textarea
                class="textarea"
                v-model="form.comment"
                :placeholder="$t('enter comment')"
                rows="6"
                required
              ></textarea>
            </div>
          </div>
        </form>
      </section>

      <footer class="modal-card-foot">
        <button
          class="button is-success is-rounded"
          @click="save"
          :disabled="is_loading"
        >
          <span class="icon" v-if="is_loading">
            <i class="fa fa-spinner fa-spin"></i>
          </span>
          <span class="icon" v-else>
            <i class="fa fa-save"></i>
          </span>
          <span>{{ $t("save") }}</span>
        </button>
        <button class="button is-rounded ml-3" @click="close">
          {{ $t("cancel") }}
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import {
  get,
  post,
  put,
  success_message,
  error_message,
  format_date,
} from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "CreditAnalysisDenyReasonModal",
  components: {
    GenericDropdown,
  },
  data() {
    return {
      is_open: false,
      is_editing: false,
      is_loading: false,
      uuid: null,
      form: {
        evaluation_uuid: null,
        comment: "",
      },
    };
  },
  methods: {
    open(evaluation_uuid = null) {
      this.is_open = true;
      this.resetForm();

      get("/credit-analysis/evaluation", { uuid: evaluation_uuid })
        .then((evaluation) => {
          this.form.comment = evaluation.comments;
        })
        .catch(() => {
          error_message(this.$t("error loading evaluation data"));
        });

      this.form.evaluation_uuid = evaluation_uuid;
    },
    close() {
      this.is_open = false;
      this.resetForm();
    },
    resetForm() {
      this.form = {
        evaluation_uuid: null,
        comment: "",
      };
    },
    save() {
      if (!this.form.evaluation_uuid || !this.form.comment) {
        error_message(this.$t("evaluation comment is required"));
        return;
      }

      this.is_loading = true;
      const data = {
        evaluation_uuid: this.form.evaluation_uuid,
        comment: this.form.comment,
      };
      post("/credit-analysis/evaluation/comment", data)
        .then(() => {
          success_message(this.$t("comment added successfully"));
          this.close();
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
  },
};
</script>

<style scoped>
.modal.is-fullscreen .modal-card {
  width: 90vw;
  height: 90vh;
  max-width: 90vw;
  max-height: 90vh;
  margin: 0;
  border-radius: 15px;
}

.modal.is-fullscreen .modal-card-body {
  max-height: calc(100vh - 120px);
  overflow-y: auto;
  padding: 2rem;
}

.modal.is-fullscreen .modal-card-head {
  border-radius: 0;
}

.modal.is-fullscreen .modal-card-foot {
  border-radius: 0;
}

.help {
  font-size: 0.875rem;
  color: #888;
}

.field {
  margin-bottom: 1.5rem;
}

/* Vertical tabs styling */
.tabs.is-vertical {
  display: block;
}

.tabs.is-vertical ul {
  flex-direction: column;
  border-bottom: none;
  /* border-right: 1px solid #dbdbdb; */
}

.tabs.is-vertical li {
  display: block;
  width: 100%;
}

.tabs.is-vertical li:not(:last-child) {
  margin-right: 0;
  margin-bottom: 0;
}

.tabs.is-vertical li a {
  /* border-bottom: 1px solid #dbdbdb; */
  border-radius: 4px 0 0 4px;
  justify-content: flex-start;
  padding: 0.75em 1em;
  display: flex;
  align-items: center;
}

.tabs.is-vertical li.is-active a {
  background-color: #3273dc;
  border-color: #3273dc;
  color: #fff;
}

.tabs.is-vertical li a:hover {
  background-color: #646060;
  border-color: #b5b5b5;
}

.tabs.is-vertical li.is-active a:hover {
  background-color: #2366d1;
  border-color: #2366d1;
}

.tab-link {
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.rule-content {
  min-height: 400px;
}

.delete.is-small {
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
}

.fixed-width-control {
  max-width: 150px;
}

.help {
  font-size: 0.875rem;
  color: #888;
}
</style>
